var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _g4, _path23, _path24, _path25, _g5, _path26, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg2MetuaaGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 51,
    viewBox: "0 0 73 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 45.6757H61.1451V48.5429H72V45.6757Z",
    fill: "url(#paint0_linear_3283_2442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4813 45.6757H7.18228V48.5429H61.4813V45.6757Z",
    fill: "#1D0C17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 48.538H8.07198V45.6708H3.05176e-05V48.538Z",
    fill: "url(#paint1_linear_3283_2442)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6288 43.6977H8.94177V40.1109H27.4889L28.6288 43.6977Z",
    fill: "#1D0C17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5451 43.6977H35.6709V40.1109H67.4052L68.5451 43.6977Z",
    fill: "#1D0C17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4457 32.1826H26.0908C24.1606 32.1826 22.5901 35.2729 22.5901 39.0827C22.5901 42.8924 24.1555 45.9827 26.0908 45.9827H31.4457C33.3759 45.9827 34.9464 42.8924 34.9464 39.0827C34.9464 35.2729 33.381 32.1826 31.4457 32.1826Z",
    fill: "#1D0C17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2176 21.5467H55.8391C55.8391 21.5467 57.3235 23.1983 57.4147 23.558C57.5058 23.9177 57.3691 25.2146 57.3691 25.2146L53.5998 24.7232L49.4 22.0786L49.2176 21.5467Z",
    fill: "#A1989B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0509 32.1826H30.6959C28.7657 32.1826 27.1952 35.2729 27.1952 39.0827C27.1952 42.8924 28.7607 45.9827 30.6959 45.9827H36.0509C37.9811 45.9827 39.5516 42.8924 39.5516 39.0827C39.5516 35.2729 37.9861 32.1826 36.0509 32.1826Z",
    fill: "#1D0C17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07363 32.1826H4.048C2.23432 32.1826 0.765137 35.2729 0.765137 39.0827C0.765137 42.8924 2.23432 45.9827 4.048 45.9827H9.07363C10.8873 45.9827 12.3565 42.8924 12.3565 39.0827C12.3565 35.2729 10.8873 32.1826 9.07363 32.1826Z",
    fill: "#1D0C17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2837 32.2279H61.9288C59.9986 32.2279 58.4281 35.3183 58.4281 39.128C58.4281 42.9377 59.9935 46.0281 61.9288 46.0281H67.2837C69.2139 46.0281 70.7844 42.9377 70.7844 39.128C70.7844 35.3183 69.219 32.2279 67.2837 32.2279Z",
    fill: "#1D0C17"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.764394 39.0922C0.755582 38.8375 0.350433 29.04 0.350433 29.04L10.2084 30.288L9.53459 37.9632C9.53459 37.9632 7.63478 37.4566 7.50813 37.4566C7.38147 37.4566 5.18783 33.9559 5.18783 33.9559L3.71358 33.2821L2.40651 34.1231L0.862026 39.0649L0.764394 39.0922Z",
    fill: "#1D0C17"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0376 32.8614L33.7001 30.1206L29.556 29.3607L25.2548 30.6678V41.4638L27.4485 41.0027L27.6156 38.3886L28.0817 35.5212L29.4293 33.5403L35.0376 32.8665V32.8614Z",
    fill: "#1D0C17"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 42.3097H70.3942C71.1119 39.8834 72.5202 34.1637 71.6375 32.2243C71.6172 31.9659 70.7437 31.7823 70.2371 31.23C69.8521 30.8146 70.0294 30.0344 69.3556 29.6646C68.6818 29.2897 67.4314 28.7829 66.0686 28.1496C62.1019 26.3156 52.1814 23.307 52.1814 23.307L47.1507 18.1138C47.1507 18.1138 47.4901 17.7186 46.6694 17.0803C45.8487 16.442 40.0438 15.2109 32.3582 15.2109C24.6726 15.2109 20.9117 15.2109 18.9474 15.2109C16.9832 15.2109 14.3372 15.5807 10.9986 17.8909C7.65495 20.2061 5.55757 22.8456 3.47031 23.9348C1.46918 24.9835 0 24.9885 0 24.9885L0.694063 32.0913C0.694063 32.0913 1.10442 31.5847 2.05686 29.158C3.01436 26.7364 31.5621 29.538 32.8438 30.6018C33.0668 30.7893 33.2643 31.0071 33.4113 31.2503C34.4042 32.8664 35.762 34.6649 36.2027 37.6387C36.6435 40.6126 36.9525 42.2996 36.9525 42.2996L36.9474 42.3097Z",
    fill: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3283_2442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 72,
    height: 28
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 42.3097H70.3941C71.1119 39.8833 72.5202 34.1637 71.6375 32.2242C71.6172 31.9659 70.7437 31.7822 70.2371 31.23C69.852 30.8146 70.0294 30.0344 69.3556 29.6645C68.6818 29.2896 67.4314 28.7828 66.0686 28.1495C62.1018 26.3156 52.1814 23.307 52.1814 23.307L47.1506 18.1137C47.1506 18.1137 47.4901 17.7186 46.6693 17.0802C45.8486 16.4419 40.0438 15.2108 32.3582 15.2108C24.6726 15.2108 20.9117 15.2108 18.9474 15.2108C16.9831 15.2108 14.3372 15.5806 10.9986 17.8908C7.65492 20.206 5.55754 22.8455 3.47028 23.9347C1.46915 24.9834 -3.05176e-05 24.9885 -3.05176e-05 24.9885L0.694032 32.0912C0.694032 32.0912 1.10439 31.5846 2.05683 29.1579C3.01433 26.7363 31.5621 29.5379 32.8438 30.6018C33.0667 30.7892 33.2643 31.0071 33.4112 31.2502C34.4042 32.8664 35.7619 34.6648 36.2027 37.6387C36.6434 40.6125 36.9525 42.2995 36.9525 42.2995L36.9474 42.3097Z",
    fill: "#E7E5E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3283_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6773 24.7097L19.4492 -0.230957L6.08472 31.7415L60.3128 56.6822L73.6773 24.7097Z",
    fill: "url(#paint2_linear_3283_2442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M74.8626 38.4392H33.4975V41.2813H74.8626V38.4392Z",
    fill: "url(#paint3_linear_3283_2442)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0755 32.4142C36.5254 29.386 31.8358 26.6807 30.3413 25.8752C29.1204 25.2217 28.6036 24.4972 28.0109 23.5499C27.2105 22.2783 24.5963 18.4736 22.884 17.0297C21.1716 15.5859 19.287 15.0995 15.457 15.6973C14.155 16.0824 12.6453 16.746 10.9988 17.8859C7.65511 20.2011 5.55772 22.8406 3.47047 23.9298C1.46934 24.9785 0.000152588 24.9887 0.000152588 24.9887L0.527032 33.1502C1.48453 30.8654 2.97905 30.4145 4.35198 30.8502C5.97314 31.3619 7.74123 33.4086 8.83045 38.0796C9.43839 40.6937 9.3472 41.4992 10.0463 41.4992H26.8052C25.9591 38.6369 26.1111 34.9791 27.0179 33.1148C27.8994 31.296 29.7131 29.9281 32.1499 31.4683C34.5817 33.0033 35.8482 37.2589 35.9597 42.3098H38.4826C38.9661 37.7141 38.8912 34.0076 38.0755 32.4142Z",
    fill: "#B9B2B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3283_2442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 39,
    height: 28
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0755 32.4142C36.5254 29.386 31.8359 26.6808 30.3414 25.8753C29.1204 25.2218 28.6037 24.4973 28.0109 23.5499C27.2105 22.2783 24.5963 18.4736 22.884 17.0298C21.1716 15.5859 19.287 15.0996 15.457 15.6974C14.155 16.0824 12.6453 16.7461 10.9988 17.886C7.65514 20.2012 5.55775 22.8407 3.4705 23.9299C1.46937 24.9786 0.000183105 24.9887 0.000183105 24.9887L0.527063 33.1503C1.48457 30.8654 2.97908 30.4146 4.35201 30.8502C5.97318 31.3619 7.74126 33.4087 8.83048 38.0796C9.43842 40.6938 9.34723 41.4993 10.0464 41.4993H26.8052C25.9591 38.6369 26.1111 34.9792 27.018 33.1148C27.8995 31.2961 29.7132 29.9282 32.15 31.4683C34.5817 33.0034 35.8483 37.2589 35.9597 42.3099H38.4827C38.9661 37.7142 38.8912 34.0076 38.0755 32.4142Z",
    fill: "#B9B2B4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3283_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9904 26.7009H-1.80844V40.5821H40.9904V26.7009Z",
    fill: "url(#paint4_linear_3283_2442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2683 51.5152L3.92654 19.6845L24.3431 4.4101L48.0274 36.2407L26.2683 51.5152Z",
    fill: "url(#paint5_linear_3283_2442)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1884 29.6852C67.4153 29.9841 67.3292 32.6134 67.3292 32.6134L71.7266 32.5881C71.7266 32.5881 71.6455 31.0074 69.381 29.675C69.3607 29.6599 69.2138 29.6801 69.1884 29.6852Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0593 16.5076C24.0593 16.5076 28.5586 16.2594 34.2327 16.3809C40.8249 16.4493 46.6696 17.0751 46.6696 17.0751L56.0115 24.5071H30.6149C30.6149 24.5071 28.1021 21.128 27.2307 19.9982C26.2834 18.7621 24.3886 16.8116 24.0543 16.5076H24.0593Z",
    fill: "#16A34A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01163 22.7948L9.07862 24.8618H22.7724C22.7724 24.8618 27.4231 24.4666 27.4586 24.5274C27.256 23.4939 25.3156 20.3731 23.0409 18.2352C20.7662 16.0973 16.6069 16.1632 14.008 17.3335C10.7403 18.7976 7.57904 22.6326 7.01163 22.7948Z",
    fill: "#16A34A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88448 25.7991C1.29681 25.8396 0.511557 25.8751 0.0505371 25.8143L0.323114 30.0163C0.323114 30.0163 1.11949 30.0242 1.39813 29.5227C1.67171 29.0313 1.92501 27.5824 1.88448 25.7991Z",
    fill: "#746A6E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3283_2442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 33,
    width: 5,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38815 39.2599C1.38815 36.2911 2.42165 33.8898 3.69325 33.8898C4.96486 33.8898 5.99835 36.2962 5.99835 39.2599C5.99835 42.2236 4.96486 44.63 3.69325 44.63C2.42165 44.63 1.38815 42.2236 1.38815 39.2599Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3283_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98822 39.2599C5.98822 42.2287 4.95979 44.63 3.68819 44.63C2.41658 44.63 1.38815 42.2236 1.38815 39.2599C1.38815 36.2962 2.41658 33.8898 3.68819 33.8898C4.95979 33.8898 5.98822 36.2962 5.98822 39.2599Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-3.1004 36.5852L4.92944 32.1168L10.5883 43.5967L2.55849 48.0651L-3.1004 36.5852Z",
    fill: "url(#paint6_linear_3283_2442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M4.88896 39.341C4.88896 41.3574 4.22529 42.9887 3.40964 42.9887C2.59399 42.9887 1.93033 41.3574 1.93033 39.341C1.93033 37.3247 2.59399 35.6934 3.40964 35.6934C4.22529 35.6934 4.88896 37.3298 4.88896 39.341Z",
    fill: "#746A6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3283_2442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 33,
    width: 6,
    height: 12
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8589 39.2599C27.8589 36.2911 28.9582 33.8898 30.3109 33.8898C31.6635 33.8898 32.7629 36.2962 32.7629 39.2599C32.7629 42.2236 31.6635 44.63 30.3109 44.63C28.9582 44.63 27.8589 42.2236 27.8589 39.2599Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3283_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7629 39.2599C32.7629 42.2287 31.6635 44.63 30.3109 44.63C28.9582 44.63 27.8589 42.2236 27.8589 39.2599C27.8589 36.2962 28.9582 33.8898 30.3109 33.8898C31.6635 33.8898 32.7629 36.2962 32.7629 39.2599Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.1091 48.0596L37.6416 43.5933L31.634 32.1164L23.1015 36.5828L29.1091 48.0596Z",
    fill: "url(#paint7_linear_3283_2442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M31.6433 39.4119C31.6433 41.6511 30.9189 43.4648 30.0222 43.4648C29.1255 43.4648 28.401 41.6511 28.401 39.4119C28.401 37.1726 29.1255 35.3589 30.0222 35.3589C30.9189 35.3589 31.6433 37.1726 31.6433 39.4119Z",
    fill: "#746A6E"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7478 29.3657C67.7498 29.5684 66.539 29.9179 65.8399 30.8602C65.4447 31.3972 65.2927 32.7094 65.2927 32.7094C65.2927 32.7094 69.3912 32.836 71.7875 32.7094C71.6457 32.218 71.0124 30.2624 68.7478 29.3657Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 28.5689C43.3233 28.5947 44.8978 28.7577 46.68 29.1382C49.6231 29.7665 50.9301 31.1141 51.0061 32.6998C47.8137 32.8927 44.8813 32.8544 42.9075 32.6978C42.8814 31.8582 42.7158 30.0917 41.8333 28.5689ZM41.2327 28.566C42.1685 29.9955 42.3615 31.791 42.3977 32.6529C42.0443 32.618 41.7301 32.5803 41.4612 32.5377C40.8736 32.4464 40.2203 31.8381 39.6429 31.2252C38.6147 30.1264 37.7967 28.807 37.7884 28.7935L37.7932 28.7886C38.9386 28.6614 40.0646 28.5739 41.2327 28.566Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3283_2442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 50,
    height: 9
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0592 16.5076C24.0592 16.5076 31.8054 16.2594 37.4795 16.3809C43.1535 16.5076 46.6695 17.075 46.6695 17.075L56.0114 24.507H30.6148C30.6148 24.507 28.102 21.1279 27.2306 19.9982C26.2833 18.762 24.3885 16.8116 24.0542 16.5076H24.0592ZM7.01163 22.7947L9.07862 24.8617H22.7724C22.7724 24.8617 27.4231 24.4665 27.4586 24.5273C27.256 23.4938 25.3156 20.3731 23.0409 18.2351C20.7662 16.0972 16.6069 16.1631 14.008 17.3334C10.7403 18.7975 7.57904 22.6326 7.01163 22.7947Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3283_2442)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.75845,
    y: 26.4781,
    width: 10.8723,
    height: 58.798,
    transform: "rotate(-90 -1.75845 26.4781)",
    fill: "url(#paint8_linear_3283_2442)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4607 24.5205H24.644C24.1069 24.5205 22.8607 21.5467 22.8607 21.5467H19.902C19.902 21.5467 18.6456 22.489 18.6456 23.4313C18.6456 24.3736 19.8108 25.5844 19.8108 25.5844H25.6572C27.5621 25.5844 27.4607 24.5205 27.4607 24.5205Z",
    fill: "#CFCBCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_2442",
    x1: 61.15,
    y1: 47.1068,
    x2: 72,
    y2: 47.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_2442",
    x1: 8.07198,
    y1: 47.1069,
    x2: 0.0000305176,
    y2: 47.1069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3283_2442",
    x1: 12.2148,
    y1: 15.5045,
    x2: 67.5472,
    y2: 40.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3283_2442",
    x1: 54.1775,
    y1: 39.3511,
    x2: 54.1775,
    y2: 41.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3283_2442",
    x1: 19.591,
    y1: 31.154,
    x2: 19.591,
    y2: 41.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3283_2442",
    x1: 31.221,
    y1: 19.1059,
    x2: 13.471,
    y2: 30.1059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#746A6E",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3283_2442",
    x1: 0.804062,
    y1: 41.1003,
    x2: 9.22253,
    y2: 36.6936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3283_2442",
    x1: 26.9612,
    y1: 41.14,
    x2: 35.5008,
    y2: 36.6699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3283_2442",
    x1: -1.75845,
    y1: 55.8771,
    x2: 9.11387,
    y2: 55.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115385,
    stopColor: "#42003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913462,
    stopColor: "#42003B",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2MetuaaGreen);
export default __webpack_public_path__ + "static/media/img2_metuaa_green.7e38a4348a895da1e960d3f7de0e78ce.svg";
export { ForwardRef as ReactComponent };